import { environmentConfig } from "@src/appV2/environment";

export const BOOKING_REQUESTS_URL = `${environmentConfig.REACT_APP_BASE_API_URL}/booking-requests`;

// eslint-disable-next-line unicorn/prefer-spread
export const UPDATE_BOOKING_REQUEST_URL = BOOKING_REQUESTS_URL.concat("/:bookingRequestId");
